import { Typography } from "@mui/material";

import { isFreePlan } from "@app/analytics/account/Billing/utils";
import CustomVocabularyModuleContent, {
  CustomVocabularyModuleUpsell,
} from "@app/analytics/account/components/CustomVocabularyModuleContent";
import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import useCustomVocabulary from "@app/analytics/hooks/settings/useCustomVocabulary";

import Stack from "@rui/Stack";

import WorkspaceSettingsAccordion from "../components/WorkspaceSettingsAccordion";

const CustomVocabularyModule = ({
  workspaceIsInactive,
}: {
  workspaceIsInactive: boolean;
}) => {
  const { currentPlan, plansInitialLoading } = useBillingContext();
  const { customVocabulary, isLoading: customVocabularyIsLoading } =
    useCustomVocabulary();

  const showUpsell =
    workspaceIsInactive ||
    (!plansInitialLoading && isFreePlan(currentPlan.type));
  const isLoading = plansInitialLoading || customVocabularyIsLoading;

  return (
    <WorkspaceSettingsAccordion
      title="Custom Vocabulary"
      subtitle="Manage custom words to boost accuracy in transcription across the Workspace"
    >
      {showUpsell ? (
        <CustomVocabularyModuleUpsell
          hasVocabulary={customVocabulary.length > 0}
          planLabel={currentPlan.label}
        />
      ) : (
        <>
          <Typography variant="bodySecondaryReg" color="shades.neutral.500">
            Adding words to your custom vocabulary helps boost recognition in
            the transcript. This improves accuracy for names, product terms, and
            jargon.
          </Typography>
          <Stack maxWidth="760px" spacing={2} paddingBottom={2}>
            <CustomVocabularyModuleContent inWorkspace isLoading={isLoading} />
          </Stack>
        </>
      )}
    </WorkspaceSettingsAccordion>
  );
};

export default CustomVocabularyModule;
